import { AuthorshipForm } from ".";
import { List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import * as Comp from "../../../../components";
import { Paths } from "../../../../constants";
import { AdminAbstractTypesLoader } from "../../../../containers/abstracts/components";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { AppState } from "../../../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
});

type OwnProps = RouteComponentProps<{}> & {
    abstract?: M.Abstract.Abstract;
    eventId: number;
    type?: M.Abstract.AbstractType;
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
};

interface OwnState {
    loadingTypes: boolean;
    types: List<M.Abstract.AbstractType>;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class AuthorshipComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private form: AuthorshipForm | null = null;

    public constructor(props: CombinedProps) {
        super(props);
        this.state = {
            loadingTypes: false,
            types: List(),
        };
    }

    public componentDidMount() {
        this._isMounted = true;
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        return <>
            <AdminAbstractTypesLoader
                eventId={this.props.eventId}
                onUpdated={async (loadingTypes, types) => await this.setStateAsync({
                    ...this.state,
                    loadingTypes,
                    types,
                })}
            />

            {this.props.abstract
                ? <h1>
                    <Link dangerouslySetInnerHTML={{ __html: this.props.abstract.title }} to={Paths.AdminAbstractDetails(this.props.eventId, this.props.abstract.guid)} />
                </h1>
                : null}

            <AuthorshipForm
                abstract={this.props.abstract}
                api={this.props.api}
                eventId={this.props.eventId}
                loadingTypes={this.state.loadingTypes}
                types={this.state.types}
                onSubmit={(model, body) => this.onSubmit(model, body)}
                ref={(ref) => this.form = ref}
            />
        </>;
    }

    private async onSubmit(model: Forms.AdminAbstract.AbstractAuthorshipData, body: any) {
        if (!this.form)
            return;

        this.form.toggleProcessing(true);
        const guid = this.props.abstract ? this.props.abstract.guid : null;
        const result = await this.props.api.post(Api.endpoints.admin.abstract.saveAuthorship, {
            body: JSON.stringify(body),
            queryParams: { guid },
        });

        if (!this._isMounted || !this.form)
            return;

        this.form.toggleProcessing(false);

        if (result.isSuccess && result.data) {
            this.props.notifySuccess(`Abstract <strong>${result.data.title}</strong><br />has been successfully saved.`);
            this.props.goto(guid === null
                ? (Paths.AdminAbstractEditDetails(this.props.eventId, result.data.guid) + "?new=true")
                : Paths.AdminAbstractDetails(this.props.eventId, guid));
        }
        else {
            this.form.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
        }
    }
}

export const Authorship: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthorshipComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/components/Authorship.tsx